import store from "../../Redux/store";
import { setOffsets, selectManageData } from "./DashboardOffset.reducer";

export function saveListOffsets(records) {
  store.dispatch(setOffsets(records));
}
export function saveSelectedManageData(offset) {
  store.dispatch(selectManageData(offset));
}
